import { finalize, merge, Observable, take, tap } from 'rxjs';
import { Pub, State, Sub } from '../../../../shared/state/state.abstract.ts';
import {
  bakery2bService,
  SaveBakery2bSettingsInput,
  SaveAllBakery2bSettingsMutationRes,
} from '../services/bakery2b.service.ts';
import { responseHandler } from '../../../../shared/responseHandler/responseHandler.ts';

class PubImpl extends Pub<IBakery2bSettingsTabState> {
  recordData(dataToSave: IBakery2bSettingsTabState['dataToSave']) {
    this.emit('recordData', { dataToSave });
  }
  saveData() {
    this.emit('saveData', {});
  }
  deleteProfileLogo() {
    this.recordData({ profileLogo: null });
    this.saveData();
  }
  deleteMenuBgImg() {
    this.recordData({ menuBgImg: null });
    this.saveData();
  }
  clearStream() {
    this.emit(undefined, {});
  }
}
class SubImpl extends Sub<IBakery2bSettingsTabState> {
  protected actionHandlers(): Observable<IBakery2bSettingsTabState> {
    return merge(this.saveData());
  }

  private saveData(): Observable<IBakery2bSettingsTabState> {
    return this.actionListener('saveData').pipe(
      tap(({ dataToSave }) => {
        bakery2bService.sub
          .saveBakery2bSettings()
          .pipe(
            responseHandler<SaveAllBakery2bSettingsMutationRes | undefined>({
              success: () => 'settings.configuration_saved',
              customErrorHandler: () => 'settings.configuration_not_saved',
            }),
            take(1),
          )
          .subscribe();

        bakery2bService.pub.saveBakery2bSettings(dataToSave);
      }),
      finalize(() => bakery2bSettingsTabState.pub.clearStream()),
    );
  }
}

class Bakery2bSettingsTabState extends State<IBakery2bSettingsTabState> {
  pub = new PubImpl(this.stream$);
  sub = new SubImpl(this.stream$);
}

export const bakery2bSettingsTabState = new Bakery2bSettingsTabState({
  action: undefined,
  dataToSave: {},
});

export interface IBakery2bSettingsTabState {
  action: undefined | 'recordData' | 'saveData';
  dataToSave: SaveBakery2bSettingsInput;
}
